import React, { Component } from 'react'
import { connect } from 'react-redux'

import Aux from '../../../hoc/ReactAux/ReactAux'
import ModalCartMessage from 'components/UI/Modal/ModalCartMessage'
import ModalErrorPlacedOrder from 'components/UI/Modal/ModalError'
import ModalSuccessPayment from 'components/UI/Modal/ModalSuccessPayment'
import ModalReceipt from 'components/UI/Modal/ModalReceipt'
import RecentlyOrdered from '../MenuComponents/RecentlyOrdered/RecentlyOrdered'
import * as menuActions from 'actions/index'
import {
  openModalReceiptOnCart,
  closeModalPlacedOrderOnCart,
  closeModalReceiptOnCart
} from 'actions/Cart'
import Cart from '../Cart/Cart'
import objectUtils from 'utils/object'
import currencyUtils from 'utils/currency'

class FastReOrder extends Component {

  state = {
    differentRestaurant: false,
    productStandBy: null,
    businessStandBy: null
  }

  componentDidMount() {
    this.setState({
      differentRestaurant: false
    });
    this.props.onChangeTitleHeader('Fast Re-order')
  }


  handleAddRecentlyOrderProduct = (item) => {
    let productsLastOrder = item.orderItems.map(function (orderItem) {
      let productMap = {
        ...orderItem.product,
        mealOptions: orderItem.mealOptions ? orderItem.mealOptions : []
      }
      productMap.price = orderItem.total
      return productMap
    })

    if (this.verifyIfRestaurantInCart(item.restaurant.id)) {
      this.setState({ productStandBy: productsLastOrder })
      this.setState({ businessStandBy: item.restaurant })
    } else {
      this.props.onAddProductToCart({ product: productsLastOrder, business: item.restaurant })
      this.props.onRestaurantSelected(item.restaurant)
    }
  }

  verifyIfRestaurantInCart = (idRestaurant) => {
    let isDifferent = !this.props.restaurantOnCart ? false : this.props.restaurantOnCart.id !== idRestaurant
    this.setState({ differentRestaurant: isDifferent })
    return isDifferent
  }

  handleConfirmOkCartModal = () => {
    this.props.onDeleteAllProductsFromCart()
    this.props.onAddProductToCart({ product: this.state.productStandBy, business: this.state.businessStandBy })
    this.props.onRestaurantSelected(this.state.businessStandBy)
    this.setState({ differentRestaurant: false })
  }

  handleDenyCartModal = () => {
    this.setState({ differentRestaurant: false })
  }

  getAmount() {
    return objectUtils.get(this.props, 'cart.payInfo.amount', 0)
  }

  getCurrency() {
    return currencyUtils.convertNameToSymbol(objectUtils.get(this.props, 'cart.restaurantSelected.currency', 'EUR'))
  }

  getSurcharge = () => {
    const isPayTypeCreditCard = payType => payType === 'C'
    const payType = objectUtils.get(this.props, 'cart.payInfo.payType', undefined)
    if (isPayTypeCreditCard(payType)) {
      return objectUtils.get(this.props, 'cart.campaignRateCC.amount', 0)
    }
    return 0
  }

  getSubTotal() {
    return objectUtils.get(this.props, 'cart.subtotal', 0)
  }

  getTaxDelivery = () => {
    return !!this.props.restaurantSelected &&
      this.props.restaurantSelected.taxDelivery &&
      this.isDeliverAtHome()
      ? this.props.restaurantSelected.taxDelivery.toFixed(2)
      : Number(0).toFixed(2);
  };

  getCollectionDiscount = () => {
    let campaignRateCollection = objectUtils.get(this.props, 'cart.campaignRateCollection', null)
    if(campaignRateCollection){
      let collectionDiscount = campaignRateCollection.discountType === 'P' ? `% ${campaignRateCollection.amount}`  : `- ${campaignRateCollection.amount}`
      return collectionDiscount
    }else{
      return '';
    }
  }

  isForCollection = () =>{
    return objectUtils.get(this.props, 'cart.restaurantSelected.forCollection', 'N')
  }

  getReceiptData = () => {
    return {
      cart: this.props.cart,
      total: this.getAmount(),
      currency: this.getCurrency(),
      surcharge: this.getSurcharge(),
      subtotal: this.getSubTotal(),
      taxDelivery: this.getTaxDelivery(),
      userDetails: this.props.userDetails,
      orderDeliveryDate: objectUtils.get(this.props, 'cart.orderDeliveryDate', undefined),
      collectionDiscount:  this.getCollectionDiscount(),
      forCollection: this.isForCollection(),
      address: this.getAddress(),
      tipValue: objectUtils.get(this.props, "cart.tipValue", 0)
    }
  }

  handleCloseModalPlacedOrderOnCart = () => {
    this.props.onCloseModalPlacedOrder(this.props.history)
  }

  getAddress = () => {
    return this.props.addresses[0];
  }

  render() {
    return (
      <Aux>
        <ModalCartMessage
          clickButtonConfirm={this.handleConfirmOkCartModal}
          clickButtonDeny={this.handleDenyCartModal}
          message={<strong>Note! You can only order from <br /> one restaurant at a time.<br />Clear current basket to add?</strong>}
          showModal={this.state.differentRestaurant} />
        <ModalErrorPlacedOrder
          style={{ zIndex: "99999", position: "absolute", margin: "5% 40%" }}
          styleContent={{ background: 'gainsboro' }}
          showModal={this.props.modalErrorPlacedOrder}
          closeModal={this.props.onCloseModalErrorPlacedOrder}
          errorMessage={this.props.errorMessage} />
        <ModalSuccessPayment
          descriptionSuccess={this.props.cart.descriptionSuccess}
          isInvoice={this.props.cart.isInvoice}
          closeModal={this.handleCloseModalPlacedOrderOnCart}
          showModal={this.props.showPlacedModal}
          openReceipt={this.props.openModalReceiptOnCart} />
        <ModalReceipt
          showModal={this.props.showReceiptModal}
          closeModal={this.props.onCloseModalReceiptOnCart}
          data={this.getReceiptData()} />
        <div className="main-content">
          <RecentlyOrdered
            restaurantsOptions={this.props.restaurantsOptions}
            fastReOrderMenu={true}
            checkout={this.props.checkout}
            addRepeatOrderProduct={this.handleAddRecentlyOrderProduct}
            showLoading={this.props.loadingRecentlyOrder}
            recentlyOrdered={this.props.recentlyOrdered} />
          <Cart />
        </div>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    userDetails: state.authenticationReducer.userDetails,
    restaurantsOptions: state.menuReducer.restaurantsOptions,
    recentlyOrdered: state.menuReducer.recentlyOrdered,
    loadingRecentlyOrder: state.menuReducer.loadingRecentlyOrder,
    checkout: state.cartReducer.cart.checkout,
    showPlacedModal: state.cartReducer.cart.showPlacedModal,
    showReceiptModal: state.cartReducer.cart.showReceiptModal,
    productsOnCart: state.cartReducer.cart.products,
    restaurantOnCart: state.cartReducer.cart.restaurantSelected,
    modalErrorPlacedOrder: state.cartReducer.cart.modalErrorPlacedOrder,
    errorMessage: state.cartReducer.cart.errorLimit,
    cart: state.cartReducer.cart,
    addresses: state.menuReducer.addresses
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onRestaurantSelected: (restaurant) => dispatch(menuActions.restaurantSelected(restaurant)),
    onAddProductToCart: (product) => dispatch(menuActions.addProductToCart(product)),
    onDeleteAllProductsFromCart: () => dispatch(menuActions.deleteAllProductsFromCart()),
    onCloseModalErrorPlacedOrder: () => dispatch(menuActions.closeModalErrorPlacedOrder()),
    onCloseModalPlacedOrder: (history) => dispatch(closeModalPlacedOrderOnCart(history)),
    openModalReceiptOnCart: () => dispatch(openModalReceiptOnCart()),
    onCloseModalReceiptOnCart: () => dispatch(closeModalReceiptOnCart()),
    onChangeTitleHeader: titleHeader => dispatch(menuActions.changeMenuTitleHeader(titleHeader)),
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(FastReOrder)



// WEBPACK FOOTER //
// ./src/containers/Menu/FastReOrder/index.js